import React, { useRef, useState, useEffect } from "react";
import "../../../../Styles/Order.css";
import { CommonPageHeading } from "../../../CommonUtilities/CommonHeading/CommonPageHeading";
import { useReactToPrint } from "react-to-print";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { FaPrint } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import { CommonAxiosGet } from "../../../CommonUtilities/CommonAxios/CommonAxios";
import { BsInfoCircle } from "react-icons/bs";
import { DscAppointmentOrderMPL } from "./DscAppointmentOrderMPL";
import { DscOrderApmsPrincipal } from "./DscOrderApmsPrincipal";
import { DscOrderZP } from "./DscOrderZP";



const Order = () => {
    const componentRef = useRef();
    const loginreducer = useSelector(
        (state) => state.reducers.loginreducer.loginDetails.loginData
    );
    let navigate = useNavigate();
    const handleprint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `Appointment_Order`,

    });

    const [orderData, setorderData] = useState();
    function getDataFunctionResult() {
        const url = `${config.url.CONTEXT_READ_URL}candidate-appointment-details`;
        CommonAxiosGet(url).then((response) => {
            if (response?.data?.status === true) {
                const posts = response?.data?.data[0];
                setorderData(posts);
            } else {
                setorderData();
            }
        });
    }
    useEffect(() => {
        getDataFunctionResult();
    }, []);
    const [showRstatus, setRstatus] = useState(false);


    return (
        <React.Fragment>
            <CommonPageHeading
                heading="MEGA DSC Appointment Order"
                drillBack="true"
                handleDrillBack={() => {
                    if (showRstatus === true) {
                        setRstatus(false);
                    } else {
                        navigate(-1);
                    }
                }}
            />


            {showRstatus === false && (
                <Row className="mt-4">
                    <Col md={2}></Col>
                    <Col md={8} className="alert alert-info text-center mt-4">
                        <BsInfoCircle color="skyblue" size="35" />
                        <h5 className="pt-4" style={{ color: "black" }}>
                            {" "}
                            Dear{" "}
                            <span style={{ color: "brown" }}>
                                {" "}
                                {loginreducer?.applicant_name}
                            </span>
                            ,<br />
                            <br />
                            <button
                                type="button"
                                onClick={() => {
                                    setRstatus(true);
                                }}
                                className="btn btn-link btn-sm"
                            >
                                👉 Click here
                            </button>
                            to download MEGA DSC - 2025 Appointment Order.
                        </h5>

                    </Col>
                    <Col md={2}></Col>{" "}
                </Row>
            )}

            {showRstatus === true && (
                <>
                    {" "}
                    <div className="">
                        <center className="mb-2">
                            <button
                                className="btn btn-secondary rounded-0"
                                variant="primary"
                                type="button"
                                onClick={() => {
                                    handleprint();
                                }}
                            >
                                Print&nbsp;{" "}
                                <FaPrint title="Print" style={{ fontSize: "22px" }} />{" "}
                            </button>
                        </center>
                    </div>
                    <div className='print-hall-hide'>
                        <div ref={componentRef}>
                            {Array.from({ length: 1 })?.map((_, index) => (
                                <div className="page-break-always">
                                    <DscOrderZP key={index} orderData={orderData} />
                                </div>
                            ))}
                        </div>


                        {/* <DscAppointmentOrderMPL orderData={orderData} /> */}
                        {/* <DSCorderAPMSZone orderData={orderData} /> */}
                        {/* <DscOrderApmsPrincipal  orderData={orderData}/> */}
                    </div>
                </>
            )}
        </React.Fragment>
    );
};
export default Order;


